import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: "type" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["value"];
const _hoisted_4 = { class: "card-input device-input" };
const _hoisted_5 = { class: "card-heading" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { key: "brand" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "card-input device-input" };
const _hoisted_11 = { class: "card-heading" };
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = { key: "model" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", {
    for: "modelSelected",
    class: "tw-block tw-mb-8 tw-text-4xl"
}, "Select a Device Model", -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Choose an Option --", -1);
const _hoisted_16 = ["value"];
const _hoisted_17 = ["label"];
const _hoisted_18 = ["value"];
import { ref, computed, } from 'vue';
import RepairFormSteps from './RepairFormSteps.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        categories: {
            type: Array,
            default: () => [],
        },
    },
    setup(__props) {
        const props = __props;
        const currentStep = ref('');
        const typeSlug = ref('');
        const brandSlug = ref('');
        const modelSlug = ref('');
        const selectedType = computed(() => props.categories?.find((x) => x.slug === typeSlug.value));
        const selectedBrand = computed(() => selectedType.value?.brands?.find((m) => m.slug === brandSlug.value));
        const selectedModel = computed(() => selectedBrand.value?.models?.find((m) => m.slug === modelSlug.value));
        const selectedBrandModelGroupings = computed(() => {
            if (!selectedBrand.value)
                return;
            const modelNamesOnly = selectedBrand.value?.models?.map(m => {
                m.parsedName = m.name.split('(')[0];
                return m;
            });
            const grouped = groupBy(modelNamesOnly, "parsedName");
            Object.keys(grouped).filter(key => grouped[key].length == 1).forEach(key => delete grouped[key]);
            return grouped;
        });
        const selectedBrandModelSingleGrouping = computed(() => {
            if (!selectedBrand.value)
                return;
            const modelNamesOnly = selectedBrand.value?.models?.map(m => {
                m.parsedName = m.name.split('(')[0];
                return m;
            });
            const grouped = groupBy(modelNamesOnly, "parsedName");
            Object.keys(grouped).filter(key => grouped[key].length !== 1).map(key => delete grouped[key]);
            let models = [];
            Object.keys(grouped).forEach(key => models = [...models, ...grouped[key]]);
            return models;
        });
        function changeStep(step, category) {
            if ((step === 'type' && category.brands.length === 0) || (step === 'brand' && category.models.length === 0)) {
                window.location.href = category.url;
                return;
            }
            if (step === 'model') {
                window.location.href = selectedModel.value.url;
                return;
            }
            currentStep.value = step;
        }
        function groupBy(items, key) {
            return items.reduce((result, item) => ({
                ...result, [item[key]]: [
                    ...(result[item[key]] || []),
                    item,
                ],
            }), {});
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(RepairFormSteps, {
                    modelValue: currentStep.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentStep).value = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                }, {
                    default: _withCtx(() => [
                        (!currentStep.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (category) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                        key: category.termId,
                                        class: "form-card device-card",
                                        onClick: ($event) => (changeStep('type', category))
                                    }, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((typeSlug).value = $event)),
                                            class: "card-input-element",
                                            type: "radio",
                                            name: "Type",
                                            value: category.slug
                                        }, null, 8, _hoisted_3), [
                                            [_vModelRadio, typeSlug.value]
                                        ]),
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("h6", _hoisted_5, _toDisplayString(category.name), 1),
                                            _createElementVNode("img", {
                                                src: category.thumbnail,
                                                class: "card-image",
                                                alt: category.name
                                            }, null, 8, _hoisted_6)
                                        ])
                                    ], 8, _hoisted_2));
                                }), 128))
                            ]))
                            : (currentStep.value === 'type')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedType).brands, (category) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                            key: category.termId,
                                            class: "form-card device-card",
                                            onClick: ($event) => (changeStep('brand', category))
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((brandSlug).value = $event)),
                                                class: "card-input-element",
                                                type: "radio",
                                                name: "Brand",
                                                value: category.slug
                                            }, null, 8, _hoisted_9), [
                                                [_vModelRadio, brandSlug.value]
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("h6", _hoisted_11, _toDisplayString(category.name), 1),
                                                _createElementVNode("img", {
                                                    src: category.thumbnail,
                                                    class: "card-image",
                                                    alt: category.name
                                                }, null, 8, _hoisted_12)
                                            ])
                                        ], 8, _hoisted_8));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _hoisted_14,
                                    _withDirectives(_createElementVNode("select", {
                                        id: "modelSelected",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((modelSlug).value = $event)),
                                        onChange: _cache[4] || (_cache[4] = ($event) => (changeStep('model', null))),
                                        class: "iresq-text-input"
                                    }, [
                                        _hoisted_15,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedBrandModelSingleGrouping), (category) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: category.id,
                                                value: category.slug
                                            }, _toDisplayString(category.name), 9, _hoisted_16));
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedBrandModelGroupings), (categories, modelType) => {
                                            return (_openBlock(), _createElementBlock("optgroup", {
                                                key: modelType,
                                                label: modelType
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories, (category) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: category.id,
                                                        value: category.slug
                                                    }, _toDisplayString(category.name), 9, _hoisted_18));
                                                }), 128))
                                            ], 8, _hoisted_17));
                                        }), 128))
                                    ], 544), [
                                        [_vModelSelect, modelSlug.value]
                                    ])
                                ]))
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
